import paymentsStudentsTraslation from './PaymentsStudents/Translations';
import checkingAccountTraslation from './CheckingAccount/Translations';
import cardRegistrationTraslation from './CardRegistration/Translations';

const paymentTranslations = {
  es_MX : {
    paymentsStudents: {...paymentsStudentsTraslation.es_MX},
    cardRegistration: {...cardRegistrationTraslation.es_MX},
  },
  es_CL : {
    paymentsStudents: {...paymentsStudentsTraslation.es_CL},
    checkingAccount: {...checkingAccountTraslation.es_CL},
    cardRegistration: {...cardRegistrationTraslation.es_CL},
  },
  es_PE: {
      paymentsStudents: {...paymentsStudentsTraslation.es_PE },
      checkingAccount: {...checkingAccountTraslation.es_PE},
      cardRegistration: {...cardRegistrationTraslation.es_PE},
  },
  es: {
    paymentsStudents: {...paymentsStudentsTraslation.es},
    checkingAccount: {...checkingAccountTraslation.es},
    cardRegistration: {...cardRegistrationTraslation.es},
  },
  en: {
    paymentsStudents: {...paymentsStudentsTraslation.en},
    checkingAccount: {...checkingAccountTraslation.en},
    cardRegistration: {...cardRegistrationTraslation.en},
  }
};

export default paymentTranslations;
